import React, { useEffect, useRef } from 'react';
import { useIntl } from '@atlassian/jira-intl';
import IssueLinkComp from '@atlassian/jira-portfolio-3-common/src/issue-link/index.tsx';
import messages from './messages.tsx';
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-global-styles -- Ignored via go/DSP-18766
import * as styles from './styles.module.css';
import type { Props } from './types.tsx';

export default function OtherIssues({
	height,
	issuesById,
	issueTypesById,
	otherIssues,
	position,
	projectsById,
	rollupBy,
}: Props) {
	const { formatMessage } = useIntl();
	const width = 300;
	const headerMessage =
		rollupBy === 'team' ? messages.issuesWithoutTeam : messages.issuesWithoutParent;

	const issuesListRef = useRef<HTMLDivElement>(null);

	// Scroll the list of issues on mouse wheel
	useEffect(() => {
		const handleWheel = (event: WheelEvent) => {
			event.stopPropagation();
		};

		const wrapper = issuesListRef.current;

		if (wrapper) {
			wrapper.addEventListener('wheel', handleWheel, {
				passive: false,
			});
		}
		return () => {
			if (wrapper) {
				wrapper.removeEventListener('wheel', handleWheel);
			}
		};
	}, []);

	return (
		<div
			// eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
			className={styles.container}
			style={{
				top: position.y - height / 2,

				left: position.x - width / 2,
				// eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
				width,
				height,
			}}
			role="button"
			// eslint-disable-next-line @typescript-eslint/no-empty-function
			onKeyDown={() => {}}
			onClick={(e) => {
				e.stopPropagation();
			}}
			tabIndex={0}
			data-testid="portfolio-3-portfolio.app-simple-plans.main.tabs.dependencies.other-issues.other-issues-group"
		>
			{/* eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766 */}
			<div className={styles.innerContent}>
				{/* eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766 */}
				<div className={styles.header}>
					{formatMessage(headerMessage, { count: otherIssues.length })}
				</div>
				{/* eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766 */}
				<div className={styles.body} ref={issuesListRef}>
					{otherIssues.map((otherIssue) => {
						const issue = issuesById[otherIssue];
						const issueType = issueTypesById[issue.type];
						const project = projectsById[issue.project];

						return (
							// eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
							<div className={styles.items} key={otherIssue}>
								<div
									// eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
									className={styles.icon}
									style={{
										backgroundImage: issueType && `url(${issueType.iconUrl})`,
									}}
								/>
								{project && (
									// eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
									<div className={styles.issueLink}>
										<IssueLinkComp issueKey={issue.issueKey} projectKey={project.key} />
									</div>
								)}
								{/* eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766 */}
								<div className={styles.issueSummary} title={issue.summary}>
									{issue.summary}
								</div>
							</div>
						);
					})}
				</div>
			</div>
		</div>
	);
}
